<sura-admin [linkActive] = "linkActive"></sura-admin>
<div class="container  pl-0 pr-0">
    <div style="padding: 10px 0px">
    </div>
    <div class="card shadow mb-5 bg-white rounded " style="margin: auto;">
     <div class="card-header">
            Administraci&oacute;n de Accesos
        </div>
        <form [formGroup]="accesoForm" class="card-body pr-0 pl-0" autocomplete="off">
            <div class="row justify-content-center">
                <div class="col-6">
                    <label class="col-md-3 col-12 col-form-label">Usuario:</label>
                    <mat-form-field class="col-md-9 col-12" appearance="outline">
                        <input matInput placeholder="" #usuario type="text" formControlName="usuario"
                            (input)="fnInputMaxLength($event);" maxlength="15"
                            (keypress)="fnKeyDownAlphaNumeric($event)" (keyup)="fnAlphaNumericMobile($event)">
                        <mat-error *ngIf="hasError('usuario')">{{obtenerMensajeError("usuario")}}</mat-error>
                    </mat-form-field>
                        </div>
                <div class="col-6 text-left pl-0 pt-4 pt-md-0 content-btn padding-top-butons-sura">
                    <button matTooltip="Buscar Usuario" mat-mini-fab color="primary" [disabled]="disableBtnSearch || (this.accesoForm.controls['usuario'].invalid && !disableBtnSearch)" class="ml-2" type="button" (click) = "buscarUsuario()">
                        <mat-icon aria-label="icon-button icon">search</mat-icon>
                    </button>
                    <button mat-mini-fab color="primary" *ngIf="!disableBtnAgregar" class="ml-2" type="button" matTooltip="Agregar Usuario"
                        (click)="agregarUsuario()">
                        <mat-icon aria-label="icon-button icon">add</mat-icon>
                    </button>
                    <button mat-mini-fab color="primary" *ngIf="!disableBtnEditar" class="ml-2" type="button" matTooltip="Editar Usuario"
                        (click)="editarUsuario()">
                        <mat-icon aria-label="icon-button icon">edit</mat-icon>
                    </button>
                    <button mat-mini-fab color="warn" *ngIf="!disableBtnCancel" class="ml-2" type="button" matTooltip="Cancelar"
                        (click)="cancelarOperacion()">
                        <mat-icon aria-label="icon-button icon">cancel</mat-icon>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <label class=" col-sm-3 col-form-label">Perfil:</label>
                    <mat-form-field class="col-md-9 col-12" appearance="outline">
                        <mat-select placeholder="Seleccione" formControlName="perfil" name="perfil">
                            <mat-option *ngFor="let perfil of listPerfil" [value]="perfil.idPerfil">
                                {{perfil.nombre}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('perfil')">{{obtenerMensajeError("perfil")}}</mat-error>
                </mat-form-field>
            </div>
                <div class="col-12 col-md-6">
                    <label class=" col-sm-3 col-12 col-form-label">Estado:</label>
                    <mat-form-field class="col-md-9 col-12" appearance="outline">
                        <mat-select placeholder="Seleccione" formControlName="estado" name="estado">
                            <mat-option *ngFor="let estado of listEstado" [value]="estado.codigo">
                                {{estado.descripcion}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="hasError('estado')">{{obtenerMensajeError("estado")}}</mat-error>
                </mat-form-field>
            </div>
            </div>
            <mat-divider class="mb-3"></mat-divider>
            <div class="row">
                <div class="col-10 col-md-6">
                    <label class="col-md-3 col-12 col-form-label">Documento:</label>
                    <mat-form-field class="col-md-5 col-7" appearance="outline">
                        <mat-select placeholder="Seleccione" formControlName="tipoDocumento" name="tipoDocumento">
                            <mat-option *ngFor="let element of listTipoDocumento" [value]="element.codigo">
                                {{element.descripcion}}
                    </mat-option>
                </mat-select>
                        <mat-error *ngIf="hasError('tipoDocumento')">{{obtenerMensajeError("tipoDocumento")}}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="col-md-4 col-5 pl-0 text-right" appearance="outline">
                        <input matInput placeholder="" #nroDocumento type="text" formControlName="nroDocumento"
                            maxlength="13" (keypress)="fnKeyDownAlphaNumeric($event)"
                            (keyup)="fnAlphaNumericMobile($event)" (input)="fnInputMaxLength($event);" (ngModelChange)="changeNroDocumento()">
                        <mat-error *ngIf="hasError('nroDocumento')">{{obtenerMensajeError("nroDocumento")}}</mat-error>
                </mat-form-field>
            </div>
                <div class="col-2 col-md-2 text-left pl-0 pt-4 pt-md-0 content-btn padding-top-butons-sura">
                    <button mat-mini-fab color="primary" *ngIf="modoActivo != 'U'"
                        [disabled]="disableBtnSearchDatosPersonales || this.accesoForm.controls['tipoDocumento'].invalid || this.accesoForm.controls['nroDocumento'].invalid"
                        class="ml-2" type="button" (click)="buscarPersona()" matTooltip="Buscar persona">
                        <mat-icon aria-label="icon-button icon">search</mat-icon>
                    </button>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-md-6">
                    <label class="col-md-3 col-12 col-form-label">Nombres:</label>
                    <mat-form-field class="col-md-9 col-12" appearance="outline">
                        <input matInput placeholder="" #nombres type="text" formControlName="nombres">
                        <mat-error *ngIf="hasError('nombres')">{{obtenerMensajeError("nombres")}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <label class="col-sm-3 col-12 col-form-label">Apellidos:</label>
                    <mat-form-field class="col-md-9 col-12" appearance="outline">
                        <input matInput placeholder="" name="apellidos" type="text" formControlName="apellidos">
                        <mat-error *ngIf="hasError('apellidos')">{{obtenerMensajeError("apellidos")}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <label class="col-sm-3 col-12 col-form-label">Correo:</label>
                    <mat-form-field class="col-md-9 col-12" appearance="outline">
                        <input matInput placeholder="" name="correo" formControlName="correo" type="text">
                        <mat-error *ngIf="hasError('correo')">{{obtenerMensajeError("correo")}}</mat-error>
                </mat-form-field>
            </div>
            </div>

            <mat-divider></mat-divider>
            <div mat-dialog-actions class="d-flex justify-content-end mt-2 pr-2">
                <button mat-raised-button type="submit" cdkFocusInitial color="primary"
                    [disabled]="desactivarBtnGuardar()" (click)="this.guardarAcceso()">
                    <mat-icon aria-label="icon-button icon" class="position-center">save</mat-icon>&nbsp;&nbsp;Guardar
                </button>
            </div>
        </form>
    </div>
</div>
